// Global
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import { classnames } from 'tailwindcss-classnames';
// Components
import Container from 'components/helpers/Container';
import PlaceholderWrapper from 'components/helpers/PlaceholderWrapper/PlaceholderWrapper';
import { Components } from '.generated/templates/Feature.Components.model';
import Heading, { propsFromFields } from 'components/helpers/Heading';
import { MissingDataSource } from 'components/helpers/EditingHelpText';

export type LayoutFiveColumnProps = Sitecore.Override.ComponentBase &
  Components.Layout.Fields.ColumnLayout;

export type LayoutFiveColumnShellProps = {
  first: JSX.Element;
  second: JSX.Element;
  third: JSX.Element;
  fourth: JSX.Element;
  fifth: JSX.Element;
};

export const LayoutFiveColumnShell = ({
  first,
  second,
  third,
  fourth,
  fifth,
}: LayoutFiveColumnShellProps): JSX.Element => {
  const columnCss = classnames('col-span-1', 'mb-0');
  return (
    <div className={classnames('md:grid', 'grid-cols-5', 'md:gap-5', 'lg:gap-7')}>
      <div className={columnCss}>{first}</div>
      <div className={columnCss}>{second}</div>
      <div className={columnCss}>{third}</div>
      <div className={columnCss}>{fourth}</div>
      <div className={columnCss}>{fifth}</div>
    </div>
  );
};

const LayoutFiveColumn = ({ rendering, fields }: LayoutFiveColumnProps): JSX.Element => {
  if (fields === null || fields === undefined) {
    return <MissingDataSource />;
  }

  const headingProps = propsFromFields(fields);

  return (
    <Container size="standard" dataComponent="authorable/layout/layout-five-column">
      <div className={fields?.description.value ? classnames('mb-8') : ''}>
        <Heading {...headingProps} descriptionClassName={classnames('text-base')} />
      </div>
      <LayoutFiveColumnShell
        first={<PlaceholderWrapper name="nmdp-one-fifth-first" rendering={rendering} />}
        second={<PlaceholderWrapper name="nmdp-one-fifth-second" rendering={rendering} />}
        third={<PlaceholderWrapper name="nmdp-one-fifth-third" rendering={rendering} />}
        fourth={<PlaceholderWrapper name="nmdp-one-fifth-fourth" rendering={rendering} />}
        fifth={<PlaceholderWrapper name="nmdp-one-fifth-fifth" rendering={rendering} />}
      />
    </Container>
  );
};

export default LayoutFiveColumn;
